import type { CombatHapticsConfig, HapticImpactStyle } from "../types";
import { hapticImpact } from "./telegram";

const DEFAULT_IMPACT: HapticImpactStyle = "medium";

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function playContinuousCharge(skillCfg: {
  charge_duration_ms?: number;
  charge_interval_ms?: number;
  charge_impact?: HapticImpactStyle;
  release_impact?: HapticImpactStyle;
}): Promise<void> {
  const duration = skillCfg.charge_duration_ms ?? 1000;
  const interval = skillCfg.charge_interval_ms ?? 45;
  const chargeImpact = skillCfg.charge_impact ?? "light";
  const releaseImpact = skillCfg.release_impact ?? "heavy";

  const deadline = Date.now() + duration;
  while (Date.now() < deadline) {
    hapticImpact(chargeImpact);
    const remaining = deadline - Date.now();
    if (remaining <= 0) break;
    await sleep(Math.min(interval, remaining));
  }
  await sleep(40);
  hapticImpact(releaseImpact);
}

export async function playSkillHaptic(
  skill: string,
  config: CombatHapticsConfig | null | undefined,
): Promise<void> {
  const skillCfg = config?.skills?.[skill];
  if (!skillCfg?.enabled) return;

  if (skillCfg.pattern === "continuous_charge") {
    await playContinuousCharge(skillCfg);
    return;
  }

  if (skillCfg.pattern === "charge_release") {
    const delays = skillCfg.charge_delay_ms ?? [70, 90, 110];
    const impacts = skillCfg.charge_impacts ?? ["light", "medium", "heavy"];
    for (let i = 0; i < impacts.length; i++) {
      if (i > 0) await sleep(delays[i - 1] ?? 80);
      hapticImpact(impacts[i] ?? "light");
    }
    await sleep(delays[delays.length - 1] ?? 100);
    hapticImpact(skillCfg.release_impact ?? "heavy");
    return;
  }

  hapticImpact(skillCfg.impact ?? DEFAULT_IMPACT);
}
